import axios from 'axios'

export default {
    namespaced: true,
    state: {
        dataProcesses: [],
        dataProcessesDetail: []
    },
    getters: {},
    mutations: {
        setDataProcesses(state, response) {
            let classification = [];
            for(var i = 0; i < response.data.length; i++){
                let procesos_equipo = [];
                let user_name = response.data[i].users.split(',');
                let type = response.data[i].types.split(',');
                let users_id = response.data[i].users_id.split(',');
                for(var j = 0; j < user_name.length; j++){
                    procesos_equipo.push({
                        'user_name': user_name[j],
                        'type' : type[j],
                        'user_id': users_id[j]
                    });
                }
                response.data[i].procesos_equipo = procesos_equipo;
                if(!classification.includes(response.data[i].clasificacion))
                {
                    classification.push(response.data[i].clasificacion);
                }
            }
            response.data.classification = classification;
            state.dataProcesses = response.data;
        },
        setDataProcessesDetail(state, response) {
            state.dataProcessesDetail = response.data;
        },
    },
    actions: {
        actionsProcesses(context, filter) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/processes/getProcessesIndex', {
                    global_filters: localStorage.getItem('global_filters')
                }).then(response => {
                    context.commit('setDataProcesses', response);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        actionsProcessesDetail(context, params) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/processes/getProcessesDetail', {
                    processId: params.thisProcessId ?? params,
                    withProcessTeam: params.withProcessTeam ?? false
                }).then(response => {
                    context.commit('setDataProcessesDetail', response);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
}